<div class="modal-header">
  <h4 class="modal-title float-left">Keyword screening - comparable acceptance criteria</h4>
  <button type="button" class="close" aria-label="Close" (click)="closeClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="false">
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Include Functions (Non Empty)</th>
        <th>Include Products (Non Empty)</th>
        <th>Exclude Keywords (Non Empty)</th>
        <th>Include Functions (Match)</th>
        <th>Include Products (Match)</th>
        <th>Exclude Keywords (Match)</th>
        <th>Keyword Screening Result</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>True</td>
        <td>True</td>
        <td>True</td>
        <td>True</td>
        <td>True</td>
        <td>False</td>
        <td class="highlight-include">Accepted Highlighted</td>
      </tr>
      <tr>
        <td>True</td>
        <td>False</td>
        <td>True</td>
        <td>True</td>
        <td>False</td>
        <td>False</td>
        <td class="highlight-include">Accepted Highlighted</td>
      </tr>
      <tr>
        <td>False</td>
        <td>True</td>
        <td>True</td>
        <td>False</td>
        <td>True</td>
        <td>False</td>
        <td class="highlight-include">Accepted Highlighted</td>
      </tr>
      <tr>
        <td>True</td>
        <td>False</td>
        <td>True</td>
        <td>True</td>
        <td>False</td>
        <td>False</td>
        <td class="highlight-include">Accepted Highlighted</td>
      </tr>
      <tr>
        <td>False</td>
        <td>True</td>
        <td>True</td>
        <td>False</td>
        <td>True</td>
        <td>False</td>
        <td class="highlight-include">Accepted Highlighted</td>
      </tr>
      <tr>
        <td>True</td>
        <td>True</td>
        <td>False</td>
        <td>True</td>
        <td>True</td>
        <td>False</td>
        <td class="highlight-include">Accepted Highlighted</td>
      </tr>
      <tr>
        <td>False</td>
        <td>False</td>
        <td>True</td>
        <td>False</td>
        <td>False</td>
        <td>True</td>
        <td>Accepted No Highlight</td>
      </tr>
    </tbody>
  </table>
  <hr />
  <div class="ey-notification-disclaimer">* (Non Empty): Keywords added to section</div>
  <div class="ey-notification-disclaimer">
    * (Match): Keywords found in Trade Description/Business Description/Both (depending on study settings).
  </div>
  <div class="ey-notification-disclaimer">* Any scenario which is not listed in the table above is classified as rejected.</div>
</div>

<div class="modal-body">
  <table class="table table-sm">
    <thead>
      <tr>
        <th colspan="2" class="accept section-diff">Words Added</th>
        <th colspan="2" class="accept">Words Matched</th>
        <th></th>
      </tr>
      <tr>
        <th class="section-diff">Include List</th>
        <th class="section-diff">Exclude List</th>
        <th>Include List</th>
        <th>Exclude List</th>
        <th>Keyword Screening Result</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th class="section-diff">x</th>
        <th class="section-diff">x</th>
        <th>x</th>
        <th></th>
        <th>Accepted</th>
      </tr>
      <tr>
        <th class="section-diff"></th>
        <th class="section-diff">x</th>
        <th></th>
        <th></th>
        <th>Accepted - no highlight</th>
      </tr>
      <tr>
        <th class="section-diff">x</th>
        <th class="section-diff">x</th>
        <th>x</th>
        <th>x</th>
        <th>Rejected</th>
      </tr>
      <tr>
        <th class="section-diff"></th>
        <th class="section-diff">x</th>
        <th></th>
        <th>x</th>
        <th>Rejected</th>
      </tr>
      <tr>
        <th class="section-diff">x</th>
        <th class="section-diff"></th>
        <th>x</th>
        <th></th>
        <th>Accepted</th>
      </tr>
      <tr>
        <th class="section-diff">x</th>
        <th class="section-diff"></th>
        <th></th>
        <th></th>
        <th>Rejected</th>
      </tr>
    </tbody>
  </table>

  <div class="ey-notification-disclaimer">* Include list is both product and function list combined (logical `AND`)</div>
  <div class="ey-notification-disclaimer">* Words added are words added to the product and/or function list</div>
  <div class="ey-notification-disclaimer">* Matched words are words found in both the trade description and/or full overview of a company</div>
  <div class="ey-notification-disclaimer">* Any scenario not listed in the table will be classified as rejection</div>
</div>
